export enum CellRunActionType {
  AddCellToken = '[Cell] AddCellToken',

  CreateRunSuccess = '[Cell] CreateRunSuccess',

  LoadLastCellRun = '[Cell] LoadLastCellRun',
  LoadLastCellRunFailure = '[Cell] LoadLastCellRunFailure',
  LoadLastCellRunSuccess = '[Cell] LoadLastCellRunSuccess',
  LoadLayoutCellRunSuccess = '[Cell] LoadLayoutCellRunSuccess',
  LoadEmbeddedCellRunSuccess = '[Cell] LoadEmbeddedCellRunSuccess',
  LoadCellRunFromBatchSuccess = '[Cell] LoadCellRunFromBatchSuccess',

  LoadCellRunResultSuccess = '[Cell] LoadCellRunResultSuccess',

  LoadCellRunResults = '[Cell] LoadCellRunResults',
  LoadCellRunResultsFailure = '[Cell] LoadCellRunResultsFailure',
  LoadCellRunResultsSuccess = '[Cell] LoadCellRunResultsSuccess',

  LoadCellRunResultContent = '[Cell] LoadCellRunResultContent',
  LoadCellRunResultContentFailure = '[Cell] LoadCellRunResultContentFailure',
  LoadCellRunResultContentSuccess = '[Cell] LoadCellRunResultContentSuccess',
}
